import React, { Component } from 'react'
import styled from 'styled-components'
import Comment from './Comment'
import Modal from '../../../common/Modal'
import NotifyBankToReviewModal from '../../modals/NotifyBankToReviewModal'
import SuccessNotification from '../../../common/SuccessNotification'

const Container = styled.div`
  margin-top: 15px;
`
const TitleContainer = styled.div`
  height: 22px;
  width: 216px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  padding-top: 10px;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

const Line = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #DBDBDC;
  margin-top: 10px;
  margin-bottom: 10px;
`
const Description = styled.div`
  color: #6A6A6A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  margin-top: 15px;
  margin-bottom: 40px;
`
const NotifyButton = styled.button`
  height: 34px;
  width: 186px;
  border-radius: 4px;
  background-color: #3399CC;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  cursor: pointer;
  color: #FFFFFF;
  border: none;
  margin-right: 15px;
  &:disabled {
    background-color: #DBDBDC;
    color: #FFFFFF;
    cursor: default;
  }
`

export default class Commentary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      bankCommentaries: this.getBankCommentry(),
      notifyButtonDisabled: props.loan.bankCommentaries.length > 0,
      isSuccessNotificationVisible: false,
    }
  }
  filterToCategory = category => {
    const commentaries = this.props.loan.bankCommentaries

    return commentaries.filter(({ category: categoryComment }) => categoryComment === category)
  }

  getTitle = name => {
    return name.split('_').map(w =>  w.substring(0,1).toUpperCase()+ w.substring(1)).join(' ')
  }

  getBankCommentry = () => {
    const defaultCategories = ['underwriting', 'closing']
    const underwriting = this.filterToCategory('underwriting')
    const closing = this.filterToCategory('closing')
    const categories = [underwriting, closing].map( (commentary, index) => {
      let bankCommentary = {}
      let category = commentary.length > 0 ? commentary[0].category : defaultCategories[index]
      bankCommentary.category = category
      bankCommentary.title = this.getTitle(category)
      bankCommentary.questions = commentary
      return bankCommentary
    })

    return categories
  }
  renderCategories = () => {
    const { isBankUser, loanId, currentAdminId } = this.props
    const { bankCommentaries } = this.state

    return (
      bankCommentaries.map((commentary, index) => {
        return (
          <Comment
            key={index}
            title={commentary.title}
            category={commentary.category}
            data={commentary.questions}
            loanId={loanId}
            currentAdminId={currentAdminId}
            isBankUser={isBankUser}
          />
        )
      })
    )
  }
  renderNotifyModal = () => {
    const { isNotifyModalOpen } = this.state
    const { adminsWithPermission, followers } = this.props.loan

    return (
      <Modal light isModalOpen={isNotifyModalOpen}>
        <NotifyBankToReviewModal
          toggleModal={() => this.toggleState('isNotifyModalOpen')}
          adminsWithPermission={adminsWithPermission}
          followers={followers}
          {...this.props}
          successReponse={this.onSuccessNotify}
        />
      </Modal>
    )
  }
  onSuccessNotify = () => {
    this.toggleState('isSuccessNotificationVisible')
    this.renderSuccessNotification();
  }
  toggleState = state => {
    this.setState({
      [state]: !this.state[state]
    })
  }
  onNotifyBankModelClick = () => {
    this.setState({
      ...this.state,
      isNotifyModalOpen: true,
    })
  }
  getDescription = () => {
    const { isBankUser } = this.props

    if (isBankUser){
      return "Use this section to ask questions not already answered in Highlights, or request information that supports approval. Responses from SmartBiz can be marked as approved to help you stay organized and aligned on remaining items."
    } else{
      return "Respond to each request or question listed below. When you're ready for the bank to review your responses, click the Notify Bank button to alert them."
    }
  }
  renderSuccessNotification = () => {
    if (this.state.isSuccessNotificationVisible) {
      return (
        <SuccessNotification duration={3}
          onClose={this.toggleSuccessNotification}
          text="Assignees have been notified to review"
        />
      )
    }
  }
  render() {
    const { isBankUser } = this.props
    const buttonTitle = `Notify ${isBankUser ? "SmartBiz" : "Bank"} to Review`
    const { notifyButtonDisabled } = this.state
    const title = 'Bank Commentary'
    const description=this.getDescription()

    return (
      <Container>
        <Header>
        <TitleContainer>
          {title}
        </TitleContainer>
        <NotifyButton
          disabled={!notifyButtonDisabled}
          onClick={this.onNotifyBankModelClick}>
            {buttonTitle}
        </NotifyButton>
        </Header>
        <Line />
        <Description>
          {description}
        </Description>
        <div>
          {this.renderCategories()}
        </div>
        {this.renderNotifyModal()}
        {this.renderSuccessNotification()}
      </Container>
    )
  }
}
